import React from "react";
import { Typography } from "@material-ui/core";

function pageSuccess() {
  return (
    <>
      <Typography variant="h5" component="h5" align="center">
        가입 성공 했습니다.
      </Typography>
      <hr />
    </>
  );
}
export default pageSuccess;
